import type { IRecordTypeDefinition } from '@platform/core/types';
import { libraryViewOf } from '../menu/libraryModes';
import { isArticleType } from '../tabs/article/articleToc';

/**
 * Вкладка, на якій подання списку відкриває запис (прототип v4): із бібліотеки статей — картки, дерево, мапа, добірки, «Найпопулярніші» —
 * «Читання» (openRead), з таблиці, карток, рядків та інших подань — типова вкладка запису («Загальне», open). Чиста функція.
 */
export function recordOpenTab(rt: IRecordTypeDefinition, view: string): string | undefined {
  return isArticleType(rt) && view === libraryViewOf(rt) ? 'read' : undefined;
}
